import { Typography } from '@mui/material';
import React from 'react';
import { Rnd } from 'react-rnd';
import { IClientPlaces, IFloorProp } from '../../all-types';

interface PlaceAreaProps {
    place: IClientPlaces;
    placeProp?: IFloorProp;
    onUpdatePosition: (place: IClientPlaces, x: number, y: number, width: number, height: number) => void;
}

export const PlaceArea: React.FC<PlaceAreaProps> = ({ place, placeProp, onUpdatePosition }) => {
    // Default values if placeMap is undefined
    const defaultDimensions = {
        width: 200,
        height: 150,
        xAxis: 50,
        yAxis: 50
    };

    // Safely get dimensions from placeProp with fallbacks
    const { width = defaultDimensions.width, 
            height = defaultDimensions.height, 
            xAxis = defaultDimensions.xAxis, 
            yAxis = defaultDimensions.yAxis, bgcolor, textColor } = place.placeMap;

    return (
        <Rnd
            size={{ width, height }}
            position={{ x: xAxis, y: yAxis }}
            onDragStop={(e, d) => onUpdatePosition(place, d.x, d.y, width, height)}
            onResizeStop={(e, direction, ref, delta, position) => {
                onUpdatePosition(
                    place,
                    position.x,
                    position.y,
                    ref.offsetWidth,
                    ref.offsetHeight
                );
            }}
            minWidth={50}
            minHeight={50}
            bounds="parent"
            style={{
                //border: '2px dashed #42a5f5',
                backgroundColor: bgcolor || 'rgba(0, 0, 0, 0.95)',
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'flex-end',
                cursor: 'grab',
                //borderRadius: '8px',
                zIndex: 5,
            }}
            dragGrid={[10, 10]} // Snap to 10px grid
            resizeGrid={[10, 10]}
            enableResizing={{
                top: true,
                right: true,
                bottom: true,
                left: true,
                topRight: true,
                bottomRight: true,
                bottomLeft: true,
                topLeft: true,
            }}
        >
            <Typography 
                variant="caption" 
                sx={{
                    color: textColor || 'primary.dark',
                    fontWeight: 'bold',
                    userSelect: 'none',
                    textAlign: 'center',
                    padding: 1,
                }}
            >
                {place.placeName || placeProp?.propName}
            </Typography>
        </Rnd>
    );
};